import React from 'react';
import { ReportIssueModal } from './report-issue-modal.component';
import { useReportIssueModalService } from './report-issue-modal.service';
import type { ReportIssueModalContainerProps } from './report-issue-modal.types';

export const ReportIssueModalContainer = (
  props: ReportIssueModalContainerProps,
) => {
  const serviceProps = useReportIssueModalService(props);
  return <ReportIssueModal {...serviceProps} />;
};
